import React, { useEffect, useRef, useState } from "react";

import {
    FaCar,
    FaChartLine,
    FaCog,
    FaGasPump,
    FaHome,
    FaMoneyBillWave,
    FaRegBell,
    FaShieldAlt,
    FaSignOutAlt,
    FaTools,
    FaUserCircle,
} from "react-icons/fa";
import { useSelector } from "react-redux";

import { useLocation } from "react-router-dom";
import ServiceLimitCarBottomSheet from "../../conponents/ServiceLimitCarBottomSheet/ServiceLimitCarBottomSheet";

import SideDrawer from "../../conponents/SideDrawer/SideDrawer";
import { selectCars } from "../../redux/car/car-slice";
import { getSubscriptionInfo } from "../../services/functions";

import styles from "./NavigationDrawer.module.css";

const NavigationDrawer = ({

    open,

    user,

    onClose,

    onNavigate,

    onLogout,

}) => {

    const [headerShadow,setHeaderShadow]=useState(false);

    const [footerShadow,setFooterShadow]=useState(false);

    const cars = useSelector(selectCars);

    const contentRef=useRef(null);

    const location = useLocation();

    const [

        limitCar,

        setLimitCar,

    ] = useState(false);

    useEffect(()=>{

        const el=contentRef.current;
    
        if(!el) return;
    
        const handleScroll=()=>{
    
            setHeaderShadow(el.scrollTop>8);
    
            setFooterShadow(
    
                el.scrollTop+el.clientHeight<el.scrollHeight-8
    
            );
    
        };
    
        handleScroll();
    
        el.addEventListener("scroll",handleScroll);
    
        return()=>el.removeEventListener("scroll",handleScroll);
    
    },[]);

    const groups = [

        [
            {
                title: "صفحه اصلی",
                icon: <FaHome />,
                path: "/",
            },

            {
                title: "خودروی جدید",
                icon: <FaCar />,
                path: "/add-car",
            },

            {
                title: "سرویس جدید",
                icon: <FaTools />,
                path: "/add-service",
            },

            {
                title: "فهرست سرویس ها",
                icon: <FaTools />,
                path: "/all-services",
            },

            {
                title: "هزینه جدید",
                icon: <FaMoneyBillWave />,
                path: "/add-expense",
            },

            {
                title: "فهرست هزینه ها",
                icon: <FaMoneyBillWave />,
                path: "/all-expense",
            },

            {
                title: "فهرست سابقه سرویس",
                icon: <FaMoneyBillWave />,
                path: "/all-operdon",
            },

            {
                title: "گزارشات و نمودارها",
                icon: <FaChartLine />,
                path: "/reports",
            },

        ],

        [

            {
                title: "اشتراک",
                icon: <FaGasPump />,
                path: "/subscription",
            },

            {
                title: "مشخصات کاربری",
                icon: <FaShieldAlt />,
                path: "/account",
            },

            // {
            //     title: "یادآورها",
            //     icon: <FaRegBell />,
            //     path: "/reminders",
            // },

        ],

        [

            {
                title: "تغییر رمز",
                icon: <FaCog />,
                path: "/change-pass",
            },

            {
                title: "درباره ما",
                icon: <FaCog />,
                path: "/contact",
            },

        ],

    ];

    const isItemActive = (path) => {

        // صفحه اصلی فقط زمانی فعال باشد که دقیقاً روی "/" باشیم
        if (path === "/") {
    
            return location.pathname === "/";
    
        }
    
        // سایر مسیرها
        return (
            location.pathname === path ||
            location.pathname.startsWith(path + "/")
        );
    
    };

    // const getSubscriptionInfo = (expireDate) => { 

    //     if (!expireDate) {
    
    //         return {
    
    //             plan: "free",
    
    //             remainingDays: 0,
    
    //         };
    
    //     }
    
    //     const today = new Date();
    
    //     const expire = new Date(expireDate);
    
    //     const diffTime = expire.getTime() - today.getTime();
    
    //     const remainingDays = Math.max(
    //         0,
    //         Math.ceil(
    //             diffTime / (1000 * 60 * 60 * 24)
    //         )
    //     );
    
    //     return {
    
    //         plan:
    
    //             remainingDays > 0
    
    //                 ? "pro"
    
    //                 : "free",
    
    //         remainingDays,
    
    //     };
    
    // };

    const subscription = getSubscriptionInfo(

        user
    
    );

    const renderItem = (item) => (

        <button

            key={item.path}

            type="button"

            className={`
                ${styles.item}
                ${
                    isItemActive(item.path)
                        ? styles.active
                        : ""
                }
            `}

            onClick={() => {

                if(item.path==="/add-car" && cars.length >= 5){
                
                    setLimitCar(true);
        
                    return;

                }

                onNavigate(item.path)
            
            }}

        >

            <span className={styles.itemIcon}>

                {item.icon}

            </span>

            <span className={styles.itemTitle}>

                {item.title}

            </span>

        </button>

    );

    return (
            <>

                <SideDrawer

                    open={open}

                    onClose={onClose}

                >

                    <div className={styles.container}>

                        <header
                            className={`${styles.header}
                            ${headerShadow ? styles.headerShadow : ""}`}
                        >

                            <div className={styles.profile}>

                                <div className={styles.avatarWrapper}>

                                    {
                                        user?.imageUrl ?

                                            <img
                                                src={user.imageUrl}
                                                alt={user.fullName}
                                                className={styles.avatar}
                                            />

                                        :

                                            <FaUserCircle
                                                className={styles.placeholder}
                                            />

                                    }

                                </div>

                                <div className={styles.userInfo}>

                                    <h3 className={styles.userName}>

                                        {user?.fullName || "کاربر"}

                                    </h3>

                                    <button
                                        type="button"
                                        className={`
                                            ${styles.subscriptionBadge}
                                            ${
                                                subscription.plan === "pro" || subscription.plan === "trial"
                                                    ? styles.pro
                                                    : styles.free
                                            }
                                        `}
                                        onClick={() => onNavigate("/subscription")}
                                    >

                                        <span className={styles.badgeTitle}>

                                            {
                                                subscription.plan === "pro" || subscription.plan === "trial"
                                                    ? "⭐ حرفه‌ای"
                                                    : "🟠 رایگان"
                                            }

                                        </span>

                                        <span className={styles.badgeText}>

                                            {
                                                subscription.plan === "pro" || subscription.plan === "trial"
                                                    ? `${subscription.remainingDays} روز باقی مانده`
                                                    : "فعال‌سازی اشتراک"
                                            }

                                        </span>

                                    </button>

                                </div>

                            </div>

                        </header>

                        <div className={styles.sectionDivider} />
                        {/* <header className={`${styles.header}

                            ${headerShadow?styles.headerShadow:""}`}>

                            <div className={styles.avatarWrapper}>

                                {

                                    user?.imageUrl

                                        ?

                                        <img

                                            src={user.imageUrl}

                                            alt={user.fullName}

                                            className={styles.avatar}

                                        />

                                        :

                                        <FaUserCircle

                                            className={styles.placeholder}

                                        />

                                }

                            </div>

                            <div className={styles.userInfo}>

                                <h3>

                                    {

                                        user?.fullName ||

                                        "کاربر"

                                    }

                                </h3>

                            </div>

                        </header>

                        <SubscriptionCard

                            plan={subscription.plan}

                            remainingDays={subscription.remainingDays}

                            onUpgrade={() =>

                                onNavigate("/subscription")

                            }

                        />

                        <div className={styles.sectionDivider} /> */}

                        <div ref={contentRef} className={styles.content}>

                            {

                                groups.map(

                                    (group, index) => (

                                        <React.Fragment key={index}>

                                            <div className={styles.group}>

                                                {

                                                    group.map(

                                                        renderItem

                                                    )

                                                }

                                            </div>

                                            {

                                                index !==

                                                groups.length - 1 && (

                                                    <div

                                                        className={styles.sectionDivider}

                                                    />

                                                )

                                            }

                                        </React.Fragment>

                                    )

                                )

                            }

                        </div>

                        <footer className={`${styles.footer}

                                        ${footerShadow?styles.footerShadow:""}`}>

                            <button

                                type="button"

                                className={`${styles.item} ${styles.logout}`}

                                onClick={onLogout}

                            >

                                <span className={styles.itemIcon}>

                                    <FaSignOutAlt />

                                </span>

                                <span className={styles.itemTitle}>

                                    خروج از حساب

                                </span>

                            </button>

                        </footer>

                    </div>

                </SideDrawer>

                <ServiceLimitCarBottomSheet

                    open={limitCar}

                    onClose={()=>setLimitCar(false)}

                />
            </>
    );

};

export default NavigationDrawer;